import React from 'react';
import { Stars } from '../Stars';
import { SectionHeading } from '../SectionHeading';
import { heroTestimonials } from '../../data/landing';
export function Testimonials() {
  return <section className="border-y border-line bg-surface px-5 py-16 md:py-24" aria-labelledby="testimonios" data-id="element-248" data-mp="3mh2bjwf1lign">
      <div className="mx-auto max-w-6xl" data-id="element-249" data-mp="3r80tt1jlcqmj">
        <div id="testimonios" data-id="element-250" data-mp="3r93hz1pj4eyr">
          <SectionHeading eyebrow="Testimonios" title="Ellos ya recuperaron su atención." data-id="element-251" data-mp="3r9bzx80ieagt" />
        </div>
        <div className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-4" data-id="element-252" data-mp="42t2rb9y6roi">
          {heroTestimonials.map(t => <figure key={t.author} className="flex flex-col rounded-3xl border border-line bg-ink p-7" data-id="element-253" data-mp="91w7svpxgxwh">
              <div className="flex items-center gap-3" data-id="element-254" data-mp="e0qptvg2mifj">
                <span className="flex h-12 w-12 items-center justify-center rounded-full border border-line bg-surface text-base font-black text-heading" data-id="element-255" data-mp="e0h0ma2uofaw">
                  {t.initials}
                </span>
                <Stars data-id="element-256" data-mp="2fslv9tbqhqpb" />
              </div>
              <blockquote className="mt-5 text-base font-medium leading-relaxed text-body" data-id="element-257" data-mp="1sl2nlxb0rw13">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-auto pt-6 text-sm font-bold text-heading" data-id="element-258" data-mp="1nshu6ww0zky3">
                — {t.author}, <span className="font-medium text-body" data-id="element-259" data-mp="1iuzjp22d0xnz">{t.meta}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}